import { render, staticRenderFns } from "./openingHours.vue?vue&type=template&id=4a14b1aa&"
import script from "./openingHours.vue?vue&type=script&lang=js&"
export * from "./openingHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports